import { AssistantConversationMessagePayloadDto } from "@core/data/dto/assistant.dto";
import { AssistantRepository } from "@core/data/repositories/assistant.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { AssistantConversation } from "@core/domain/models/assistant-conversation.model";
import { AssistantMessage } from "@core/domain/models/assistant-message.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class SendAssistantMessageUseCase {
    constructor(
        @inject(AssistantRepository)
        private readonly repository: AssistantRepository,
    ) {}

    async execute(
        conversationId: number,
        payload: AssistantConversationMessagePayloadDto,
    ): Promise<
        Either<
            FallbackError,
            {
                conversation: AssistantConversation;
                userMessage: AssistantMessage;
                assistantMessage: AssistantMessage;
            }
        >
    > {
        return this.repository.sendMessage(conversationId, payload);
    }
}
